// test510
(510 && 0);
